// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDelinquentClaimsMultiEmployersSummaryRecordDto
 */
export interface IDelinquentClaimsMultiEmployersSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IDelinquentClaimsMultiEmployersSummaryRecordDto
     */
    account_type?: string;
    /**
     * 
     * @type {number}
     * @memberof IDelinquentClaimsMultiEmployersSummaryRecordDto
     */
    paid_requiring_docs?: number;
    /**
     * 
     * @type {number}
     * @memberof IDelinquentClaimsMultiEmployersSummaryRecordDto
     */
    repayment_required?: number;
    /**
     * 
     * @type {number}
     * @memberof IDelinquentClaimsMultiEmployersSummaryRecordDto
     */
    locked_purses_count?: number;
}

/**
 * Check if a given object implements the IDelinquentClaimsMultiEmployersSummaryRecordDto interface.
 */
export function instanceOfIDelinquentClaimsMultiEmployersSummaryRecordDto(value: object): value is IDelinquentClaimsMultiEmployersSummaryRecordDto {
    return true;
}

export function IDelinquentClaimsMultiEmployersSummaryRecordDtoFromJSON(json: any): IDelinquentClaimsMultiEmployersSummaryRecordDto {
    return IDelinquentClaimsMultiEmployersSummaryRecordDtoFromJSONTyped(json, false);
}

export function IDelinquentClaimsMultiEmployersSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDelinquentClaimsMultiEmployersSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'paid_requiring_docs': json['paid_requiring_docs'] == null ? undefined : json['paid_requiring_docs'],
        'repayment_required': json['repayment_required'] == null ? undefined : json['repayment_required'],
        'locked_purses_count': json['locked_purses_count'] == null ? undefined : json['locked_purses_count'],
    };
}

export function IDelinquentClaimsMultiEmployersSummaryRecordDtoToJSON(json: any): IDelinquentClaimsMultiEmployersSummaryRecordDto {
    return IDelinquentClaimsMultiEmployersSummaryRecordDtoToJSONTyped(json, false);
}

export function IDelinquentClaimsMultiEmployersSummaryRecordDtoToJSONTyped(value?: IDelinquentClaimsMultiEmployersSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_type': value['account_type'],
        'paid_requiring_docs': value['paid_requiring_docs'],
        'repayment_required': value['repayment_required'],
        'locked_purses_count': value['locked_purses_count'],
    };
}

